import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Achievement, CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';
import { CmsService } from 'src/app/services/cms.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.scss']
})
export class AchievementComponent implements OnInit {
  public dateTimeFormat = environment.dateTimeFormat;
  public achievements: Achievement[] = null;
  public loading = false;

  constructor(
    private router: Router,
    private cms: CmsService,
    private server: CmsServerService,
    private notification: NotificationsService
  ) {}

  public ngOnInit() {
    return this.server.achievementList().then(achievements => {
      this.achievements = achievements.filter(a => a.type === 'achievement');
      this.loading = false;
    });
  }

  public i18nLocked(a: Achievement): any {
    return this.localized(a?.i18n_locked);
  }

  public i18nAchieved(a: Achievement): any {
    return this.localized(a?.i18n_achieved);
  }

  public localized(container: any, fallback: any = {}): any {
    if (!container) return fallback;
    const lang = this.cms.language;
    return container[lang] ?? fallback;
  }

  public languages(a: Achievement): string[] {
    return Object.keys(a.i18n_achieved);
  }

  public navigate(uuid: string) {
    this.loading = true;
    return this.router.navigate(['/achievement', uuid]).finally(() => (this.loading = false));
  }

  public remove(achievement: Achievement, index: number) {
    this.loading = true;
    return this.server
      .achievementDelete(achievement.uuid, true, false)
      .then(() => this.achievements.splice(index, 1))
      .then(() => this.notification.notify('success', 'Deleted', `The Achievement was successfully deleted!`))
      .finally(() => (this.loading = false));
  }
}
